import FlightItineraries from "./FlightItinearies";

export default FlightItineraries;